import PropTypes from 'prop-types';

import { getPagePath, trans } from '@spotahome/soyuz/client';

import MobileMenuItem from '../../MobileMenu/MobileMenuItem';
import MobileMenuLink from '../../MobileMenu/MobileMenuLink';
import { DSIcon } from '../../../../base';
import CreateAnAccount from '../../LoginButtonComponent/CreateAnAccount';
import SeparatorRedesign from '../../MobileMenu/SeparatorRedesign';

const HeaderNavMobileNotLogged = ({ changeCity = false }) => {
  return (
    <>
      <MobileMenuItem>
        <MobileMenuLink
          onClick={() => {}}
          className="ga-signup-menu-button"
          dataTest="signup-hamburger-link"
        >
          <CreateAnAccount />
        </MobileMenuLink>
      </MobileMenuItem>

      <SeparatorRedesign />

      <MobileMenuItem>
        <MobileMenuLink
          onClick={() => {}}
          className="ga-login-menu-button"
          dataTest="login-hamburger-link"
        >
          {trans('login.text')}
        </MobileMenuLink>
      </MobileMenuItem>

      <SeparatorRedesign />
      <MobileMenuItem>
        <MobileMenuLink
          href={getPagePath('marketplace.favorites')}
          target="_blank"
          rel="nofollow"
        >
          <DSIcon name="fav_line" /> {trans('favorites.title.favorites')}
        </MobileMenuLink>
      </MobileMenuItem>

      {changeCity && (
        <MobileMenuItem>
          <MobileMenuLink className="change-city" href={getPagePath('landing')}>
            <DSIcon name="map" /> {trans('change_city.title')}
          </MobileMenuLink>
        </MobileMenuItem>
      )}

      <MobileMenuItem>
        <MobileMenuLink
          className="faqs-mobile"
          target="_blank"
          href={getPagePath('how-it-works')}
        >
          <DSIcon name="double_bed" />
          {trans('how_it_works.title')}
        </MobileMenuLink>
      </MobileMenuItem>

      <MobileMenuItem>
        <MobileMenuLink
          className="faqs-mobile"
          target="_blank"
          href={getPagePath('externals.help-center')}
        >
          <DSIcon name="help_circle" />
          {trans('menu.support-center.help-guide')}
        </MobileMenuLink>
      </MobileMenuItem>

      <MobileMenuItem>
        <MobileMenuLink
          className="faqs-mobile"
          target="_blank"
          href={getPagePath('refer-a-friend')}
        >
          <DSIcon name="diamond" /> {trans('my-referrals.cta.revamp')}
        </MobileMenuLink>
      </MobileMenuItem>
    </>
  );
};

HeaderNavMobileNotLogged.propTypes = {
  changeCity: PropTypes.bool
};

export default HeaderNavMobileNotLogged;
